export const PRIMARY = "#B21414";
export const SECONDARY = "#063970";
export const FADEDGRAY = "rgb(211,211,211, 0.5)";